import React, { createContext, useEffect, useReducer } from "react"
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom"
import { reducer, initialState } from "./reducers/userReducer"
import ProtectedRoutes from "./utils/ProtectedRoutes"
import Home from "./pages/Home"
import BuyRealestate from "./pages/BuyRealestate"
import SellRealestate from "./pages/SellRealestate"
import SingleRealestate from "./pages/SingleRealestate"
import About from "./pages/About"
import Contact from "./pages/Contact"
import Login from "./pages/Login"
import Dashboard from "./pages/Dashboard"
import RealestateDashboard from "./pages/RealestateDashboard"
import RealestateOrders from "./pages/RealestateOrders"

export const UserContex = createContext()

const defaultDescription =
  "Saamling is a trusted Bhutan real estate brokerage for verified homes, apartments, land and commercial property for sale and rent."

const routeMetadata = [
  { pattern: /^\/$/, title: "Saamling | Property for Sale & Rent in Bhutan" },
  {
    pattern: /^\/(properties|buyrealestate)(\/|$)/,
    title: "Properties for Sale & Rent in Bhutan | Saamling",
    description: "Browse verified houses, apartments, land and commercial properties across Bhutan with Saamling."
  },
  {
    pattern: /^\/(list-your-property|sellrealestate)(\/|$)/,
    title: "List Your Property in Bhutan | Saamling",
    description: "List your Bhutan property with Saamling and connect with serious buyers and tenants through a local brokerage team."
  },
  { pattern: /^\/about(\/|$)/, title: "About Saamling | Bhutan Real Estate Brokerage" },
  { pattern: /^\/contactus(\/|$)/, title: "Contact Saamling | Bhutan Property Experts" },
  { pattern: /^\/login(\/|$)/, title: "Staff Login | Saamling" },
  { pattern: /^\/(dashboard|realestatedashboard|realestateorders)(\/|$)/, title: "Brokerage Dashboard | Saamling" }
]

function setMetaContent(attribute, value, content) {
  let element = document.head.querySelector(`meta[${attribute}="${value}"]`)
  if (!element) {
    element = document.createElement("meta")
    element.setAttribute(attribute, value)
    document.head.appendChild(element)
  }
  element.setAttribute("content", content)
}

function BrandMetadata() {
  const { pathname } = useLocation()

  useEffect(() => {
    const metadata = routeMetadata.find(({ pattern }) => pattern.test(pathname)) || {}
    const title = metadata.title || "Saamling | Bhutan Real Estate"
    const description = metadata.description || defaultDescription

    document.title = title
    setMetaContent("name", "description", description)
    setMetaContent("property", "og:title", title)
    setMetaContent("property", "og:description", description)
    setMetaContent("name", "twitter:title", title)
    setMetaContent("name", "twitter:description", description)
  }, [pathname])

  return null
}

function App() {
  const [state, dispatch] = useReducer(reducer, initialState)
  return (
    <UserContex.Provider value={{ state, dispatch }}>
      <BrowserRouter>
        <BrandMetadata />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/properties" element={<BuyRealestate />} />
          <Route path="/buyrealestate" element={<Navigate to="/properties" replace />} />
          <Route path="/properties/:productid" element={<SingleRealestate />} />
          <Route path="/singlerealestate/:productid" element={<SingleRealestate />} />
          <Route path="/list-your-property" element={<SellRealestate />} />
          <Route path="/sellrealestate" element={<Navigate to="/list-your-property" replace />} />
          <Route path="/about" element={<About />} />
          <Route path="/contactus" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoutes />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/realestatedashboard" element={<RealestateDashboard />} />
            <Route path="/realestateorders" element={<RealestateOrders />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </UserContex.Provider>
  )
}

export default App
